import ErpDashboard from '../shared/ErpDashboard';

function StaffDashboardHome({ user }) {
  return <ErpDashboard user={user} mode="staff" />;
}

export default StaffDashboardHome;
